<template>
  <div v-bind="$attrs" v-html="compiledMarkdown"></div>
</template>

<script>
import {marked} from "marked";

export default {
  name: "MarkedWrapper",
  props: {
    content: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    compiledMarkdown() {
      // Convert the markdown content to HTML
      marked.use({
        renderer: {
          link: (token) => {
            return `<a href="${token.href}" target="_blank">${token.text}</a>`;
          },
          code: (token) => {
            return `<div>${token.text}</div>`;
          }
        }
      });
      return marked.parse(this.content || '', this.options);
    }
  }
};
</script>

<style scoped>
/* You can add some custom styles for the rendered markdown content */
</style>
